const formatDateToYYYYMMDD = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const JSONtoTrendData = (data, type, options) => {
  console.log(data);
  console.log(options);
  let retDataJson = {
    "reportType": type,
    "query": [],
    "data": [],
    "genderage": []
  };
  let retDataSet = [];
  let start_date = new Date(data.dateRange[0]);
  let end_date = new Date(data.dateRange[1]);
  const endDateObj = new Date();
  endDateObj.setDate(endDateObj.getDate() - 1);
  start_date.setHours(9, 0, 0, 0);
  end_date.setHours(9, 0, 0, 0);
  endDateObj.setHours(9, 0, 0, 0);
  let diff_date = (end_date.getTime() - start_date.getTime()) / (1000 * 60 * 60 * 24);
  let diff_date_Obj = (endDateObj.getTime() - start_date.getTime()) / (1000 * 60 * 60 * 24);

  switch (type) {
    case "volume": {
      let pushDate = new Date(start_date);

      for (let j = 0; j < diff_date_Obj + 1; j++) {
        retDataJson.data.push({
          "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
        })
        pushDate.setDate(pushDate.getDate() + 1);
      }

      data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
        const pcTimes = resultJson.pcTimes;
        const moTimes = resultJson.moTimes;
        const pcData = resultJson.pcData.results[0];
        const moData = resultJson.moData.results[0];

        retDataJson.query.push(resultJson.keyword)

        let pcRatio = pcData.data[pcData.data.length - 1].ratio;
        for (let i = pcData.data.length - 1; i >= 0; i--) {
          const currentRatio = pcData.data[i].ratio;
          if (currentRatio !== 0) {
            pcRatio = currentRatio;

            break;
          }
        }

        let moRatio = moData.data[moData.data.length - 1].ratio;
        for (let i = moData.data.length - 1; i >= 0; i--) {
          const currentRatio = moData.data[i].ratio;
          if (currentRatio !== 0) {
            moRatio = currentRatio;

            break;
          }
        }

        pcData.data.forEach((item, dataIndex) => {
          retDataJson.data[dataIndex][`pc${resultJsonIndex}`] = Math.round((item.ratio / pcRatio) * pcTimes);
        })
        moData.data.forEach((item, dataIndex) => {
          retDataJson.data[dataIndex][`mo${resultJsonIndex}`] = Math.round((item.ratio / moRatio) * moTimes);
        })

        retDataJson.data.forEach((item, dataIndex) => {
          const pcValue = item[`pc${resultJsonIndex}`];
          console.log(dataIndex + ": " + item[`pc${resultJsonIndex}`])
          const moValue = item[`mo${resultJsonIndex}`];
          item[`all${resultJsonIndex}`] = pcValue + moValue;
        })
      })

      for (let i = 0; i < diff_date_Obj - diff_date; i++) {
        retDataJson.data.pop();
      }

      switch (options.timeunit) {
        case "weekly": {
          let weeklyData = [];
          let weeklyPushDate = new Date(start_date);
          for (let j = 0; j < diff_date + 1; j++) {
            if (j % 7 == 0) {
              weeklyData.push({
                "date": weeklyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
                "end_date": "",
              })
            }
            if (j % 7 == 6 || j == diff_date) {
              weeklyData[parseInt(j / 7)]['end_date'] = weeklyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")
            }

            weeklyPushDate.setDate(weeklyPushDate.getDate() + 1);
          }
          data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
            weeklyData.forEach(weeklyItem => {
              weeklyItem[`pc${resultJsonIndex}`] = 0
              weeklyItem[`mo${resultJsonIndex}`] = 0
              weeklyItem[`all${resultJsonIndex}`] = 0
            })

            weeklyData.forEach(weeklyItem => {
              retDataJson.data.filter(retDataItem => retDataItem.date.replace(/\-/g, "") >= weeklyItem.date.replace(/\-/g, "") && retDataItem.date.replace(/\-/g, "") <= weeklyItem.end_date.replace(/\-/g, "")).forEach((filteredItem) => {
                weeklyItem[`pc${resultJsonIndex}`] += filteredItem[`pc${resultJsonIndex}`];
                weeklyItem[`mo${resultJsonIndex}`] += filteredItem[`mo${resultJsonIndex}`];
                weeklyItem[`all${resultJsonIndex}`] += filteredItem[`all${resultJsonIndex}`];
              })
            })
          })
          retDataJson.data = weeklyData;
          break;
        }
        case "monthly": {
          let monthlyData = [];
          let monthlyPushDate = new Date(start_date);
          let diff_year = end_date.getFullYear() - start_date.getFullYear();
          let diff_month = end_date.getMonth() - start_date.getMonth();
          let diff_total_month = diff_year * 12 + diff_month;

          for (let j = 0; j < diff_total_month + 1; j++) {
            monthlyData.push({
              "date": monthlyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
              "end_date": "",
            })
            if (j == diff_total_month) {
              monthlyData[j]['end_date'] = end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            else {
              monthlyPushDate.setFullYear(monthlyPushDate.getFullYear(), monthlyPushDate.getMonth() + 1, 0);
              monthlyData[j]['end_date'] = monthlyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }

            monthlyPushDate.setFullYear(monthlyPushDate.getFullYear(), monthlyPushDate.getMonth() + 1, 1);
          }
          data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
            monthlyData.forEach(monthlyItem => {
              monthlyItem[`pc${resultJsonIndex}`] = 0
              monthlyItem[`mo${resultJsonIndex}`] = 0
              monthlyItem[`all${resultJsonIndex}`] = 0
            })

            monthlyData.forEach(monthlyItem => {
              retDataJson.data.filter(retDataItem => retDataItem.date.replace(/\-/g, "") >= monthlyItem.date.replace(/\-/g, "") && retDataItem.date.replace(/\-/g, "") <= monthlyItem.end_date.replace(/\-/g, "")).forEach((filteredItem) => {
                monthlyItem[`pc${resultJsonIndex}`] += filteredItem[`pc${resultJsonIndex}`];
                monthlyItem[`mo${resultJsonIndex}`] += filteredItem[`mo${resultJsonIndex}`];
                monthlyItem[`all${resultJsonIndex}`] += filteredItem[`all${resultJsonIndex}`];
              })
            })
          })
          retDataJson.data = monthlyData;
          break;
        }
        default:
          break;
      }
      break;
    }
    case "detail": {
      let apiCheckFailed = false; // 실패 플래그

      for (const resultJson of data.resultJsonArray) {
        if (resultJson.ageGenderRatios == null) {
          apiCheckFailed = true;
          break;
        }
      }

      if (apiCheckFailed) {
        alert("API KEY CHECK");

        console.log("API Key 문제로 'detail' 케이스 처리를 중단합니다.");
        return retDataJson;
      }

      retDataJson.genderage = Object.keys(options.selections).filter(key => options.selections[key] === true);


      let pushDate = new Date(start_date);

      for (let j = 0; j < diff_date_Obj + 1; j++) {
        retDataJson.data.push({
          "date": pushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
        })
        pushDate.setDate(pushDate.getDate() + 1);
      }

      data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
        const pcTimes = resultJson.pcTimes;
        const moTimes = resultJson.moTimes;
        const pcData = resultJson.pcData.results[0];
        const moData = resultJson.moData.results[0];

        retDataJson.query.push(resultJson.keyword)

        let pcRatio = pcData.data[pcData.data.length - 1].ratio;
        for (let i = pcData.data.length - 1; i >= 0; i--) {
          const currentRatio = pcData.data[i].ratio;
          if (currentRatio !== 0) {
            pcRatio = currentRatio;

            break;
          }
        }

        let moRatio = moData.data[moData.data.length - 1].ratio;
        for (let i = moData.data.length - 1; i >= 0; i--) {
          const currentRatio = moData.data[i].ratio;
          if (currentRatio !== 0) {
            moRatio = currentRatio;

            break;
          }
        }

        pcData.data.forEach((item, dataIndex) => {
          retDataJson.data[dataIndex][`pc${resultJsonIndex}`] = Math.round((item.ratio / pcRatio) * pcTimes);
        })
        moData.data.forEach((item, dataIndex) => {
          retDataJson.data[dataIndex][`mo${resultJsonIndex}`] = Math.round((item.ratio / moRatio) * moTimes);
        })

        retDataJson.data.forEach((item, dataIndex) => {
          const pcValue = item[`pc${resultJsonIndex}`];
          const moValue = item[`mo${resultJsonIndex}`];
          item[`all${resultJsonIndex}`] = pcValue + moValue;
        })

      })

      for (let i = 0; i < diff_date_Obj - diff_date; i++) {
        retDataJson.data.pop();
      }

      switch (options.timeunit) {
        case "weekly": {
          let weeklyData = [];
          let weeklyPushDate = new Date(start_date);
          for (let j = 0; j < diff_date + 1; j++) {
            if (j % 7 == 0) {
              weeklyData.push({
                "date": weeklyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
                "end_date": "",
              })
            }
            if (j % 7 == 6 || j == diff_date) {
              weeklyData[parseInt(j / 7)]['end_date'] = weeklyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-")
            }

            weeklyPushDate.setDate(weeklyPushDate.getDate() + 1);
          }
          data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
            weeklyData.forEach(weeklyItem => {
              weeklyItem[`pc${resultJsonIndex}`] = 0
              weeklyItem[`mo${resultJsonIndex}`] = 0
              weeklyItem[`all${resultJsonIndex}`] = 0
            })

            weeklyData.forEach(weeklyItem => {
              retDataJson.data.filter(retDataItem => retDataItem.date.replace(/\-/g, "") >= weeklyItem.date.replace(/\-/g, "") && retDataItem.date.replace(/\-/g, "") <= weeklyItem.end_date.replace(/\-/g, "")).forEach((filteredItem) => {
                weeklyItem[`pc${resultJsonIndex}`] += filteredItem[`pc${resultJsonIndex}`];
                weeklyItem[`mo${resultJsonIndex}`] += filteredItem[`mo${resultJsonIndex}`];
                weeklyItem[`all${resultJsonIndex}`] += filteredItem[`all${resultJsonIndex}`];
              })
            })
          })
          retDataJson.data = weeklyData;
          break;
        }
        case "monthly": {
          let monthlyData = [];
          let monthlyPushDate = new Date(start_date);
          let diff_year = end_date.getFullYear() - start_date.getFullYear();
          let diff_month = end_date.getMonth() - start_date.getMonth();
          let diff_total_month = diff_year * 12 + diff_month;

          for (let j = 0; j < diff_total_month + 1; j++) {
            monthlyData.push({
              "date": monthlyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-"),
              "end_date": "",
            })
            if (j == diff_total_month) {
              monthlyData[j]['end_date'] = end_date.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }
            else {
              monthlyPushDate.setFullYear(monthlyPushDate.getFullYear(), monthlyPushDate.getMonth() + 1, 0);
              monthlyData[j]['end_date'] = monthlyPushDate.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/\//g, "-");
            }

            monthlyPushDate.setFullYear(monthlyPushDate.getFullYear(), monthlyPushDate.getMonth() + 1, 1);
          }
          data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
            monthlyData.forEach(monthlyItem => {
              monthlyItem[`pc${resultJsonIndex}`] = 0
              monthlyItem[`mo${resultJsonIndex}`] = 0
              monthlyItem[`all${resultJsonIndex}`] = 0
            })

            monthlyData.forEach(monthlyItem => {
              retDataJson.data.filter(retDataItem => retDataItem.date.replace(/\-/g, "") >= monthlyItem.date.replace(/\-/g, "") && retDataItem.date.replace(/\-/g, "") <= monthlyItem.end_date.replace(/\-/g, "")).forEach((filteredItem) => {
                monthlyItem[`pc${resultJsonIndex}`] += filteredItem[`pc${resultJsonIndex}`];
                monthlyItem[`mo${resultJsonIndex}`] += filteredItem[`mo${resultJsonIndex}`];
                monthlyItem[`all${resultJsonIndex}`] += filteredItem[`all${resultJsonIndex}`];
              })
            })
          })
          retDataJson.data = monthlyData;
          break;
        }
        default:
          break;
      }

      data.resultJsonArray.forEach((resultJson, resultJsonIndex) => {
        let total_all = 0;
        for (const gender in resultJson.ageGenderRatios) {
          for (const ageGroup in resultJson.ageGenderRatios[gender]) {
            total_all += resultJson.ageGenderRatios[gender][ageGroup]["pc"];
            total_all += resultJson.ageGenderRatios[gender][ageGroup]["mo"];
          }
        }
        const denominator = total_all > 0 ? total_all : 1;

        const transformedData = {
          all: 0,
          female: 0,
          male: 0,
          '10f': 0, '20f': 0, '30f': 0, '40f': 0, '50f': 0,
          '10m': 0, '20m': 0, '30m': 0, '40m': 0, '50m': 0,
        };

        const getTargetKey = (ageGroup, gender) => {
          const genderSuffix = gender === 'f' ? 'f' : 'm';
          if (ageGroup === '0-12' || ageGroup === '13-19') return '10' + genderSuffix;
          if (ageGroup === '20-24' || ageGroup === '25-29') return '20' + genderSuffix;
          if (ageGroup === '30-39') return '30' + genderSuffix;
          if (ageGroup === '40-49') return '40' + genderSuffix;
          if (ageGroup === '50-') return '50' + genderSuffix;
          return null;
        };

        for (const gender in resultJson.ageGenderRatios) {
          let totalGenderSearch = 0;
          const genderKey = gender === 'f' ? 'female' : 'male';

          for (const ageGroup in resultJson.ageGenderRatios[gender]) {
            const pc = resultJson.ageGenderRatios[gender][ageGroup]["pc"];
            const mo = resultJson.ageGenderRatios[gender][ageGroup]["mo"];
            const currentTotal = pc + mo;

            // 전체 합계 및 성별 합계
            totalGenderSearch += currentTotal;

            // 타겟 키 (예: '20f', '30m') 계산
            const targetKey = getTargetKey(ageGroup, gender);

            if (targetKey) {
              // 해당 연령대 키에 누적 합산 (0-12, 13-19는 10대로, 20-24, 25-29는 20대로 합산됨)
              transformedData[targetKey] += currentTotal;
            }
          }

          // 성별 전체 합계 저장
          transformedData[genderKey] = totalGenderSearch;
          transformedData.all += totalGenderSearch; // 전체(all) 합계 누적
        }

        const finalRatios = {};
        for (const key in transformedData) {
          // 모든 값은 total_all로 나누어 비율로 변환합니다.
          finalRatios[key] = transformedData[key] / denominator;
        }

        retDataJson.data.forEach(dataItem => {

          const bases = ['pc', 'mo', 'all']; // 계산 대상 필드의 접두사 (pc, mo, all)

          // options.selections 객체를 순회하여 true인 키에 대해서만 계산 수행
          for (const selectionKey in options.selections) {

            // 1. selectionKey가 true이고 finalRatios에 해당 비율이 존재할 경우
            if (options.selections[selectionKey] === true && finalRatios[selectionKey] !== undefined) {

              const ratioValue = finalRatios[selectionKey]; // 예: 1 또는 0.08499...

              // 2. pc, mo, all 세 가지 기본 필드에 대해 반복
              bases.forEach(base => {
                // 현재 키워드 인덱스에 해당하는 필드 이름 생성 (예: 'pc0', 'mo1')
                const originalKey = `${base}${resultJsonIndex}`;

                // 3. 원본 값 가져오기
                const originalValue = dataItem[originalKey];

                if (originalValue !== undefined) {

                  // 4. 새 속성 이름 설정 (예: pc0-all, mo1-30f)
                  const newKey = `${originalKey}-${selectionKey}`;

                  // 5. 계산 수행 및 반올림
                  const calculatedValue = Math.round(originalValue * ratioValue);

                  // 6. retDataJson.data 배열의 해당 dataItem에 새 속성 추가/업데이트
                  dataItem[newKey] = calculatedValue;
                }
              });
            }
          }
        });
      })
      break;
    }
    default:
      break;
  }

  console.log(retDataJson)
  return retDataJson;
}

export default JSONtoTrendData;